import { Qr } from '@cheqroom/icons';
import { FC } from 'react';

import { Info } from '../Info';

export interface QRCodeProps {
	codes: string[];
}

export const QRCode: FC<QRCodeProps> = ({ codes }) => {
	if (!codes.length) return null;

	return <Info icon={Qr} text={codes[0]} />;
};
